import { render, staticRenderFns } from "./VideoRoomContainer.vue?vue&type=template&id=2f2e0bc6&scoped=true"
import script from "./VideoRoomContainer.vue?vue&type=script&lang=js"
export * from "./VideoRoomContainer.vue?vue&type=script&lang=js"
import style0 from "./VideoRoomContainer.vue?vue&type=style&index=0&id=2f2e0bc6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e0bc6",
  null
  
)

export default component.exports